import { render, staticRenderFns } from "./RecoverPasswordCognito.vue?vue&type=template&id=1dfc4ae3&scoped=true&"
import script from "./RecoverPasswordCognito.vue?vue&type=script&lang=js&"
export * from "./RecoverPasswordCognito.vue?vue&type=script&lang=js&"
import style0 from "./RecoverPasswordCognito.vue?vue&type=style&index=0&id=1dfc4ae3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfc4ae3",
  null
  
)

export default component.exports